/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We work with third-party service providers who assist us in operating our platform:`)
};

const es_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajamos con proveedores de servicios de terceros que nos ayudan a operar nuestra plataforma:`)
};

const de_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir arbeiten mit Drittanbieter-Dienstleistern zusammen, die uns beim Betrieb unserer Plattform unterstützen:`)
};

const nl_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We werken samen met externe dienstverleners die ons helpen bij het beheren van ons platform:`)
};

const fr_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous travaillons avec des prestataires de services tiers qui nous aident à exploiter notre plateforme :`)
};

const it_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collaboriamo con fornitori di servizi terzi che ci assistono nella gestione della nostra piattaforma:`)
};

const pt_br2_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhamos com provedores de serviços terceirizados que nos auxiliam na operação da nossa plataforma:`)
};

const pt_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhamos com prestadores de serviços terceiros que nos auxiliam na operação da nossa plataforma:`)
};

const ja_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォームの運営を支援するサードパーティサービスプロバイダーと連携しています:`)
};

const zh_privacy_section_5_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们与协助运营平台的第三方服务提供商合作：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_5_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_5_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_5_intro", locale)
	if (locale === "en") return en_privacy_section_5_intro(inputs)
	if (locale === "es") return es_privacy_section_5_intro(inputs)
	if (locale === "de") return de_privacy_section_5_intro(inputs)
	if (locale === "nl") return nl_privacy_section_5_intro(inputs)
	if (locale === "fr") return fr_privacy_section_5_intro(inputs)
	if (locale === "it") return it_privacy_section_5_intro(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_5_intro(inputs)
	if (locale === "pt") return pt_privacy_section_5_intro(inputs)
	if (locale === "ja") return ja_privacy_section_5_intro(inputs)
	return zh_privacy_section_5_intro(inputs)
};